import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

const initialState = {
  pageNavigation: "",
  showSidebar: true,
  auth: Cookies.get('token') ? true : false,
  activeTab: localStorage.getItem('adminActiveTab') || 'stores',
};

export const featuresSlice = createSlice({
  name: "features",
  initialState,
  reducers: {
    updatePageNavigation: (state, action) => {
      state.pageNavigation = action.payload;
    },
    updateSidebar: (state, action) => {
      state.showSidebar = action.payload;
    },
    updateAuth: (state, action) => {
      state.auth = action.payload;
    },
    updateActiveTab: (state, action) => {
      state.activeTab = action.payload;
      localStorage.setItem('adminActiveTab', action.payload);
    },
  },
});

export const { updatePageNavigation, updateSidebar, updateAuth, updateActiveTab } = featuresSlice.actions;
export const featuresReducer = featuresSlice.reducer; 